<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Store Management
          </v-toolbar-title>
          <v-spacer></v-spacer>  
          <v-card-actions class="justify-center">
            <!-- Godawn -->
            <router-link style="text-decoration: none;" v-if="$route.path!='/godown-reports'" to="/godown-reports">
              <v-btn  outlined style="margin: 0px 15px;">
                <v-icon left color='teal'>store</v-icon>
                  Store Reports
              </v-btn>
            </router-link>

            <!-- Godawn -->
            <router-link style="text-decoration: none;" v-if="$route.path!='/godawn'" to="/godawn">
              <v-btn  outlined style="margin: 0px 15px;">
                <v-icon left color='teal'>store</v-icon>
                  Visit Stores
              </v-btn>
            </router-link>

            <!-- start of Godawn -->
            <v-btn 
              @click="getFirms"
              outlined>
              <v-icon left color='teal'>add</v-icon> 
              New Store
            </v-btn>
          </v-card-actions>
          <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link> -->
        </v-toolbar>  
        
        <v-card>
            <template v-for="(item, index) in getGodawnAccount">
              <v-divider :key="item['.key']"></v-divider>
              <v-card :key="index">
                <v-card-title>
                  <!-- <v-card-text>  -->
                  Godawn Name :- &nbsp; <b class="primary--text font-weight-bold">{{item.godawnName}}</b> &nbsp; &nbsp; &nbsp;
                  Godawn Address :- &nbsp; <b class="primary--text font-weight-bold">{{item.godawnAddress}}</b> &nbsp; &nbsp; &nbsp;
                  Godawn Pincode :- &nbsp; <b class="primary--text font-weight-bold">{{item.godawnPincode}}</b> &nbsp; &nbsp; &nbsp;       
                  <v-btn flat icon class="yellow white--text" @click="editGodawnAccount(item)">
                    <v-icon color="grey white--text">edit</v-icon>
                  </v-btn>  
                  <v-btn flat icon class="error white--text" @click="deleteGodawnAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <!-- </v-card-text> -->
                </v-card-title>
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Godawn Account</span> 
        </v-card-title>
        <v-card-text>
          <v-text-field label="Godawn Name" v-model="godawnName" ></v-text-field>
          <v-text-field label="Address" v-model="godawnAddress" ></v-text-field>
          <v-text-field label="Pincode" v-model="godawnPincode" ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="addNewGodawnAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogEdit" persistent max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Edit Godawn Details</span> 
        </v-card-title>
        <v-card-text>
          <v-text-field label="Edit Godawn Name" v-model="godawnNameEdit" ></v-text-field>
          <v-text-field label="Edit Address" v-model="godawnAddressEdit"></v-text-field>
          <v-text-field label="Edit Pincode" v-model="godawnPincodeEdit"></v-text-field>  
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialogEdit">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="updateNewGodawnAccount">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-snackbar
      v-model="snackbar"
      top
      color="error"
      :timeout="3000"
    >
   {{snackbarText}}
    </v-snackbar>
    <v-snackbar
      v-model="snackbarSuccess"
      top
      color="success"
      :timeout="3000"
    >
   {{snackbarSuccessText}}
    </v-snackbar>
  </v-layout>

</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { debug, debuglog } from 'util';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Godawn',
  data () {
    return {
      dialog: false,
      dialogEdit: false,
      items:null,
      currentFirm:"",
      godawnName: null,
      godawnAddress: null,
      godawnPincode: null,
      godawnNameEdit: null,
      godawnAddressEdit: null,
      godawnPincodeEdit: null,
      snackbarSuccessText:null,
      snackbarText:null,
      snackbar : false,
      snackbarSuccess:false,
      itemsEdit:null,
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'account',
      this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'godawn',
      this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getGodawnAccount () {
      if (this.selectedBrand) {
        return this.godawn.filter(item => item['brand'] === this.selectedBrand && item['firm'] != '')
      }
    },
    godawnCount () {
      return this.getGodawnAccount.length || 0
    }  
  },
  methods: {
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    addNewGodawnAccount () {
          let data ={
            brand:this.selectedBrand,
            godawnName:this.godawnName,
            godawnAddress:this.godawnAddress,
            godawnPincode:this.godawnPincode,
          }
    
        if (data.godawnName == null || data.godawnName == ""){    
            this.snackbar = true;
            this.snackbarText = 'Enter Godawn Name';
            return false;
        }

        this.$root.$firebaseRefs.godawn.push(data);
        // this.addInvoice();
        this.dialog=false;
        this.godawnName=null;
        this.godawnAddress=null;
        this.godawnPincode=null;
    },

    editGodawnAccount(key){
      this.dialogEdit = true;
      console.log(key)
      let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.itemsEdit = totalitem;

      this.dialogEdit=true;
      this.godawnNameEdit=key.godawnName;
      this.godawnAddressEdit=key.godawnAddress;
      this.godawnPincodeEdit=key.godawnPincode;
      this.updateKey=key['.key']
    },
    updateNewGodawnAccount(){
      let data ={
          brand:this.selectedBrand,
          godawnName:this.godawnNameEdit,
          godawnAddress:this.godawnAddressEdit,
          godawnPincode:this.godawnPincodeEdit,
        }
        this.$root.$firebaseRefs.godawn.child(this.updateKey).update({
          brand:this.selectedBrand,
          godawnName:this.godawnNameEdit,
          godawnAddress:this.godawnAddressEdit,
          godawnPincode:this.godawnPincodeEdit,
        });
        // this.addInvoice();
        this.godawnNameEdit="";
        this.godawnAddressEdit="";
        this.godawnPincodeEdit="";
        this.cancelDialogEdit();
    },

    deleteGodawnAccount(key){
      confirm('Are you sure you want to delete this Godawn Account') &&
      this.$root.$firebaseRefs.godawn.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
    },
    cancelDialogEdit(){
      this.dialogEdit = false;
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
        this.itemsEdit = totalitem;
    },
    getGodawnAccount () {
      this.dialog =true;
        let godawn = this.godawn.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        godawn.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Godawn/index.vue